// 封装token的存储
// token存储到localStorage

// 存token
export function saveToken(token) {
  localStorage.setItem("token", token);
}
// 读取token
export function getToken() {
  return localStorage.getItem("token");
}
// 删除token
export function deleteToken() {
  localStorage.removeItem("token");
}
